export function updateFunds(funds, { setState }) {
  const currency = Object.keys(funds)[0];
  const amount = funds[currency];
  setState('user.funds.amount', amount);
  setState('user.funds.currency', currency);
}

export function getFundsAmount({ getState }) {
  return getState('user.funds.amount', 0);
}

export function getFundsCurrency({ getState }) {
  return getState('user.funds.currency', '');
}

export function getFunds(ctx) {
  return {
    amount: getFundsAmount(ctx),
    currency: getFundsCurrency(ctx),
  };
}
